/* AutoLinkr Lite — shared interactivity for al-lite-* sections.
   Guarded so it initialises once no matter how many sections inject the tag.
   - Scroll reveal: IntersectionObserver + a 1400ms fallback that force-shows
     content (carry-forward reliability detail from the mockup).
   - Accordions: event delegation on [data-alite-acc] groups.
   Runs on initial load and re-runs in the Shopify theme editor on section load. */
(function () {
  if (window.__aliteInit) return;
  window.__aliteInit = true;

  function revealAll(root) {
    (root || document).querySelectorAll(".alite-reveal:not(.is-in)").forEach(function (el) {
      el.classList.add("is-in");
    });
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll(".alite-reveal:not(.is-in)");
    if (!("IntersectionObserver" in window)) { revealAll(root); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
    // Reliability fallback: if the observer never fires, show everything.
    setTimeout(function () { revealAll(root); }, 1400);
  }

  // Accordion: a group wraps items; each trigger toggles its own item and
  // (single-open mode) closes siblings.
  function onAccClick(e) {
    var trigger = e.target.closest("[data-alite-acc-trigger]");
    if (!trigger) return;
    var item = trigger.closest("[data-alite-acc-item]");
    var group = trigger.closest("[data-alite-acc]");
    if (!item || !group) return;
    var single = group.getAttribute("data-alite-acc") !== "multi";
    var isOpen = item.classList.contains("is-open");
    if (single) {
      group.querySelectorAll("[data-alite-acc-item].is-open").forEach(function (it) {
        if (it !== item) it.classList.remove("is-open");
      });
    }
    item.classList.toggle("is-open", !isOpen);
  }

  // Hero gallery: clicking a thumbnail swaps the main image + active state.
  function onGalleryClick(e) {
    var thumb = e.target.closest("[data-alite-gallery-thumb]");
    if (!thumb) return;
    var gal = thumb.closest("[data-alite-gallery]");
    if (!gal) return;
    var main = gal.querySelector("[data-alite-gallery-main]");
    var src = thumb.getAttribute("data-src");
    if (main && src) main.setAttribute("src", src);
    gal.querySelectorAll("[data-alite-gallery-thumb].is-active").forEach(function (t) {
      t.classList.remove("is-active");
    });
    thumb.classList.add("is-active");
  }

  // Hero offer selector: picking an offer updates the buy form's variant +
  // quantity, the Add-to-Cart label, and the headline price/compare/save.
  function onOfferClick(e) {
    var btn = e.target.closest("[data-alite-offer]");
    if (!btn) return;
    var group = btn.closest("[data-alite-offers]");
    if (group) {
      group.querySelectorAll("[data-alite-offer].is-selected").forEach(function (o) {
        o.classList.remove("is-selected");
      });
    }
    btn.classList.add("is-selected");

    var form = btn.closest("[data-alite-atc-form]");
    if (form) {
      var idIn = form.querySelector("[data-alite-atc-id]");
      var qtyIn = form.querySelector("[data-alite-atc-qty]");
      var atcBtn = form.querySelector("[data-alite-atc-btn]");
      var variant = btn.getAttribute("data-variant");
      var qty = btn.getAttribute("data-qty") || "1";
      var atc = btn.getAttribute("data-atc");
      if (idIn && variant) idIn.value = variant;
      if (qtyIn) qtyIn.value = qty;
      if (atcBtn && atc) atcBtn.textContent = atc;
    }

    var section = btn.closest(".alite-hero") || document;
    var pn = section.querySelector("[data-alite-price-now]");
    var pw = section.querySelector("[data-alite-price-was]");
    var ps = section.querySelector("[data-alite-price-save]");
    if (pn) pn.textContent = btn.getAttribute("data-price") || "";
    if (pw) pw.textContent = btn.getAttribute("data-compare") || "";
    if (ps) ps.textContent = btn.getAttribute("data-save") || "";

    syncStickyFromOffer(btn);
  }

  // Sticky bar: mirror the currently-selected offer (variant, qty, price, label)
  // so its self-contained /cart/add form always submits the chosen offer.
  function syncStickyFromOffer(btn) {
    if (!btn) return;
    var id = btn.getAttribute("data-variant");
    var qty = btn.getAttribute("data-qty") || "1";
    var price = btn.getAttribute("data-price") || "";
    var atc = btn.getAttribute("data-atc") || ("Add to Cart — " + price);
    document.querySelectorAll("[data-alite-sticky-id]").forEach(function (el) { if (id) el.value = id; });
    document.querySelectorAll("[data-alite-sticky-qty]").forEach(function (el) { el.value = qty; });
    document.querySelectorAll("[data-alite-sticky-price]").forEach(function (el) { el.textContent = price; });
    document.querySelectorAll("[data-alite-sticky-atc-label]").forEach(function (el) { el.textContent = atc; });
  }

  // Sticky bar: sync to the default-selected offer on load, then reveal it once
  // the hero's Add-to-Cart button has scrolled out of view above the viewport.
  function initSticky() {
    var bar = document.querySelector("[data-alite-stickybar]");
    if (!bar) return;
    var selected = document.querySelector("[data-alite-offer].is-selected") || document.querySelector("[data-alite-offer]");
    if (selected) syncStickyFromOffer(selected);

    var anchor = document.querySelector("[data-alite-atc-btn]");
    if (anchor && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var pastTop = e.boundingClientRect.top < 0;
          bar.classList.toggle("is-visible", !e.isIntersecting && pastTop);
        });
      }, { threshold: 0 });
      io.observe(anchor);
    } else {
      window.addEventListener("scroll", function () {
        bar.classList.toggle("is-visible", window.scrollY > 700);
      }, { passive: true });
    }
  }

  function boot() {
    initReveal(document);
    document.addEventListener("click", onAccClick);
    document.addEventListener("click", onGalleryClick);
    document.addEventListener("click", onOfferClick);
    initSticky();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Shopify theme editor: reveal freshly-loaded sections immediately.
  document.addEventListener("shopify:section:load", function (e) {
    revealAll(e.target);
  });
})();
